<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
            <h1>EChartBar <small><i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1>
            <ol class="breadcrumb">
                <li>
                    <router-link to="/"> <i class="ti-home"></i></router-link>
                </li>
                <li><a href="#">Charts</a></li>
                <li class="active">EChart Bar</li>
            </ol>
        </section>
        <!-- Main content -->
        <section class="content">
            <div class="row">
                <div class="col-md-12">
                    <!-- Default box -->
                    <div class="box">
                        <div class="box-body">
                            <ve-histogram :data="chartData" :settings="chartSettings"></ve-histogram>
                        </div>
                        <!-- /.box-body -->
                    </div>
                </div>
            </div>
        </section>
        <!-- /.content -->
    </div>
</template>
<script>
  module.exports = {
    created: function () {
      this.chartData = {
        columns: ['date', 'cost', 'profit', 'growthRate', 'people'],
        rows: [
          { 'date': '01/01', 'cost': 1523, 'profit': 1523, 'growthRate': 0.12, 'people': 100 },
          { 'date': '01/02', 'cost': 1223, 'profit': 1921, 'growthRate': 0.345, 'people': 100 },
          { 'date': '01/03', 'cost': 2123, 'profit': 5523, 'growthRate': 0.7, 'people': 100 },
          { 'date': '01/04', 'cost': 4123, 'profit': 6523, 'growthRate': 0.31, 'people': 100 }
        ]
      }
      this.chartSettings = {
        metrics: ['profit', 'cost', 'people', 'growthRate'],
        showLine: ['cost'],
        label: {
          normal: { show: true, position: 'top' }
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// ChartBar.vue?19d30274